import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  return (
  <div className="max-w-2xl mx-auto px-4 py-12">
    <div className="bg-white rounded-2xl shadow-xl border border-blue-100 p-8 flex flex-col items-center text-center">
      <h1 className="text-3xl font-extrabold text-blue-900 mb-2 tracking-wide">{t('about.title')}</h1>
      <p className="text-lg text-gray-700 mb-6">Sistema desarrollado para <span className="font-bold text-blue-700">Novolex</span></p>
      <div className="w-full border-t border-gray-200 mb-6"></div>
      <div className="mb-4">
        <span className="block text-xl font-bold text-blue-800 mb-1">MCS Emmanuel Cardenaz</span>
        <span className="block text-base font-semibold text-gray-700 mb-1">IT – Data Analyst & SQF Practitioner | Durobag | Rio Bravo</span>
        <span className="block text-gray-600 mb-1">Brecha 27400, Solidaridad, Rio Bravo, Tamaulipas 88920</span>
        <span className="block text-gray-600 mb-1">Emmanuel.cardenaz@novolex.com</span>
        <span className="block text-gray-600">m 899-301-0780 | o +1 859-488-8427</span>
      </div>
      <div className="w-full border-t border-gray-200 mt-6"></div>
      <p className="mt-6 text-sm text-gray-400">&copy; {new Date().getFullYear()} Novolex. Todos los derechos reservados.</p>
    </div>
  </div>
  );
};

export default About;
